import { render, staticRenderFns } from "./TicketList.vue?vue&type=template&id=27e6921e&scoped=true&"
import script from "./TicketList.vue?vue&type=script&lang=js&"
export * from "./TicketList.vue?vue&type=script&lang=js&"
import style0 from "./TicketList.vue?vue&type=style&index=0&id=27e6921e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e6921e",
  null
  
)

export default component.exports